<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'app',
}
</script>

<style lang="stylus">
#app
  width:100%
  background:#ebebeb
</style>
